import React, { useEffect } from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { keyframes } from '@emotion/react';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

// Definizione delle animazioni
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const scaleIn = keyframes`
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
`;

// Stili componenti
const AnimatedBox = styled(Box)`
  animation: ${fadeIn} 0.8s ease-out;
`;

const AnimatedCheckIcon = styled(CheckCircleIcon)`
  animation: ${scaleIn} 0.5s ease-out;
  color: #4CAF50;
  font-size: 80px;
  margin-bottom: 20px;
`;

const PaymentSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Reindirizza alla home dopo 5 secondi
    const timer = setTimeout(() => {
      navigate('/');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container maxWidth="sm">
      <AnimatedBox
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: 2,
            bgcolor: 'background.paper',
          }}
        >
          <AnimatedCheckIcon />
          <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ fontWeight: 'bold' }}>
            Pagamento Completato con Successo!
          </Typography>
          <Typography variant="body1" align="center" color="text.secondary" sx={{ mt: 2 }}>
            Grazie per il tuo acquisto. La tua quota di scansioni è stata aggiornata.
          </Typography>
          <Typography variant="body2" align="center" color="text.secondary" sx={{ mt: 2 }}>
            Verrai reindirizzato alla home page tra pochi secondi...
          </Typography>
        </Paper>
      </AnimatedBox>
    </Container>
  );
};

export default PaymentSuccess; 